export default __webpack_public_path__ + "static/media/dune001.96f3e11e.jpg";